export const resetChecked = () => {
  document.querySelectorAll('.list-course-checked').forEach( el => el.checked = false );
}